module.exports = __webpack_public_path__ + "img/logoGreenStar.c3a0703c.png";